(window as any).__appBooted = true;
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initNativeApp } from "./lib/capacitor";

// Unregister service workers in preview/iframe contexts to prevent stale cache issues
const isInIframe = (() => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
})();

const isPreviewHost =
  window.location.hostname.includes("id-preview--") ||
  window.location.hostname.includes("lovableproject.com");

// Bump this string to force a one-shot cache + service worker purge on all clients.
// Each client only runs the purge once per version (tracked in localStorage).
const CACHE_PURGE_VERSION = "2026-10-10-1";

async function purgeAllClientCaches(reload: boolean) {
  try {
    const regs = (await navigator.serviceWorker?.getRegistrations()) ?? [];
    await Promise.all(regs.map((r) => r.unregister()));
  } catch (e) {
    console.warn("SW unregister failed:", e);
  }
  try {
    const names = (await caches?.keys()) ?? [];
    await Promise.all(names.map((n) => caches.delete(n)));
  } catch (e) {
    console.warn("cache clear failed:", e);
  }
  if (reload) {
    // Hard reload bypassing bfcache/disk cache
    window.location.reload();
  }
}

if (isPreviewHost || isInIframe) {
  // Always purge in preview/iframe — no reload to avoid loops in the editor
  void purgeAllClientCaches(false);
} else {
  // Production: one-shot forced purge per CACHE_PURGE_VERSION
  try {
    const last = localStorage.getItem("cache_purge_version");
    if (last !== CACHE_PURGE_VERSION) {
      localStorage.setItem("cache_purge_version", CACHE_PURGE_VERSION);
      void purgeAllClientCaches(true);
    } else if ("serviceWorker" in navigator) {
      // /sw.js é o kill-switch legado (push + limpeza de cache); o SW do PWA
      // (workbox) vive em /pwa-sw.js para não sobrescrever o kill-switch.
      navigator.serviceWorker.register("/pwa-sw.js").catch((err) => {
        console.warn("SW registration failed:", err);
      });

      // Quando o SW novo (kill-switch) ativar e assumir controle de uma aba
      // que ainda estava sendo servida pelo SW antigo, recarregamos UMA VEZ
      // para garantir que o usuário receba o bundle JS/HTML mais recente.
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data?.type === "SW_ACTIVATED") {
          const key = `sw_reloaded_${event.data.version}`;
          if (!sessionStorage.getItem(key)) {
            sessionStorage.setItem(key, "1");
            window.location.reload();
          }
        }
      });
    }
  } catch {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/pwa-sw.js").catch(() => {});
    }
  }
}

createRoot(document.getElementById("root")!).render(<App />);

// Initialize native Capacitor plugins (no-op on web)
initNativeApp();
